<script setup>
import LoginForm from "@/components/teacher/LoginForm.vue";
</script>

<template>
  <LoginForm />
</template>
